import { InfoOutlined } from '@mui/icons-material'

import CustomButton from '@/components/inputs/CustomButton'
import { useBidOverviewDrawer } from '@/features/bidding/contexts/BidOverviewDrawerContextProvider'
import { useFeatureToggle } from '@/features/featureToggle/contexts/FeatureToggleContext'

function BidOverviewButton() {
  const { open: openBidOverviewDrawer } = useBidOverviewDrawer()
  const { isEnabled } = useFeatureToggle()

  if (!isEnabled('FLEX_PORTAL_DRAWER_BID_OVERVIEW_ENABLED')) {
    return null
  }

  return (
    <CustomButton color="inheritWhite" startIcon={<InfoOutlined />} onClick={openBidOverviewDrawer}>
      Bid Overview
    </CustomButton>
  )
}

export default BidOverviewButton
